import { useSelector } from "react-redux";
import styles from "./style";
import { useEffect, useRef } from "react";
import { Highlight } from "../Highlight";

const AutocompleteHits = ({
    id,
    autocompleteFocusIndex,
    showHits,
    onHitClick
}) => {
    const {
        hits,
        query,
    } = useSelector((state) => state.searcher);
    const autocompleteResultsRef = useRef(null);
    const focusedIndex = autocompleteFocusIndex !== undefined && hits.length
        ? autocompleteFocusIndex % hits.length
        : undefined;

    useEffect(() => {
        if (focusedIndex !== undefined) doScroll(focusedIndex);
    }, [focusedIndex, hits]);

    const doScroll = (autocompleteFocusIndex) => {
        const children = autocompleteResultsRef.current.children;
        const focusedItem = children[autocompleteFocusIndex];

        if (focusedItem) {
            const containerHeight = autocompleteResultsRef.current.clientHeight;

            const itemOffsetTop = focusedItem.offsetTop;
            const itemHeight = focusedItem.clientHeight;

            const scrollTo = Math.max(0, itemOffsetTop + itemHeight - containerHeight);

            autocompleteResultsRef.current.scrollTo({
                top: scrollTo,
            });
        }
    };

    //Se hace con este evento en vez de onClick ya que al perder el foco si no no se ejecuta
    const handleMouseDown = (event, hit) => {
        event.preventDefault();
        //Click derecho
        if (event.button === 0) {
            onHitClick({ hit });
        }
    }

    return (
        <div id={id} role="listbox" aria-label="Sugerencias de modelos y marcas" className={`searcher-results ${showHits ? '' : 'hide'}`} ref={autocompleteResultsRef}>
            {query && hits && hits.map((hit, index) => (
                <div id={`${id}-option-${index}`} role="option" aria-selected={focusedIndex === index} className={`result-item ${focusedIndex === index ? 'focused' : ''}`} key={index} onMouseDown={(e) => handleMouseDown(e, hit)}>
                    {<Highlight attribute="name" hit={hit} className="text text-color--gp--black text-kind--span text-align--left text-wrap--pretty text-size--caption text-gp--font-regular" />}
                </div>
            ))
            }
            <style jsx>{styles}</style>
        </div>
    );
};

export default AutocompleteHits;
